import React from "react";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { 
  Plus, 
  User, 
  Building2, 
  DollarSign, 
  Calendar, 
  GitBranch 
} from "lucide-react";
import { useCanEdit } from '@/hooks/auth';

interface QuickAddDropdownProps {
  onLeadCreate: () => void;
  onCompanyCreate: () => void;
  onDealCreate: () => void;
  onActivityCreate: () => void;
}

export const QuickAddDropdown = ({ 
  onLeadCreate, 
  onCompanyCreate, 
  onDealCreate, 
  onActivityCreate 
}: QuickAddDropdownProps) => {
  const { canEdit } = useCanEdit();
  const navigate = useNavigate();

  const quickActions = [
    {
      label: "Lead",
      icon: User,
      action: onLeadCreate,
      shortcut: "L"
    },
    {
      label: "Empresa",
      icon: Building2,
      action: onCompanyCreate,
      shortcut: "E"
    },
    {
      label: "Negócio",
      icon: DollarSign,
      action: onDealCreate,
      shortcut: "D"
    },
    {
      label: "Atividade",
      icon: Calendar,
      action: onActivityCreate,
      shortcut: "A"
    },
    {
      label: "Cadência",
      icon: GitBranch,
      href: "/sequences/new",
      shortcut: "S"
    }
  ];

  const handleAction = (action: any) => {
    if (action.href) {
      navigate(action.href);
    } else if (action.action) {
      action.action();
    }
  };

  if (!canEdit) {
    return null;
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="sm" className="h-9 w-9 p-0 nav-action-btn">
            <Plus className="h-4 w-4" />
            <span className="sr-only">Adicionar</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>Adicionar novo</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {quickActions.map((action) => {
            const Icon = action.icon;
            return (
              <DropdownMenuItem
                key={action.label}
                onClick={() => handleAction(action)}
                className="flex items-center justify-between cursor-pointer"
              >
                <div className="flex items-center space-x-2">
                  <Icon className="h-4 w-4" />
                  <span>{action.label}</span>
                </div>
                <kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
                  {action.shortcut}
                </kbd>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};